import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

import { ENV } from "@/utils/env";

const postLogout = async () => {
  const response = await axios.post(
    `${ENV.serviceUrl || "http://localhost:8000"}/api/v1/admin/auth/logout`,
    {},
    { withCredentials: true }
  );
  localStorage.removeItem("access_token");
  localStorage.removeItem("userid");
  localStorage.removeItem("username");

  return response;
};

export const usePostLogout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postLogout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["logout"] });
    },
  });
};
